<template>
  <Modal v-model="standardShippingSettingsModal" :title="$t('key1006269')" width="650" class-name="standardShippingSettingsStyles"
    :transfer="false" :mask-closable="false" @on-visible-change="standardShippingSettingsChange">
    <div class="flex align-items-center mb15">
      <span>{{ $t('key1006414') }}</span>
      <RadioGroup v-model="configType">
        <Radio :label="1">{{ $t('key1006415') }}</Radio>
        <Radio :label="2">{{ $t('key1006416') }}</Radio>
      </RadioGroup>
    </div>
    <h2 class="font-size-15 mb10">{{ $t('key1006412') + configCharacters() + $t('key1006413')}}</h2>
    <!--全局统一配置-->
    <template v-if="configType === 1">
      <RadioGroup v-model="selectValue" class="radio_box_style">
        <template v-for="item in groupKeyList">
          <Radio :label="item.key">{{ item.name }}</Radio>
        </template>
      </RadioGroup>
    </template>
    <!--按平台配置-->
    <template v-else>
      <div class="platformConfiguration" v-for="item in platformConfigList">
        <h2 class="font-size-15 title_bold mb5">{{ item.name }}</h2>
        <RadioGroup v-model="item.selectValue" class="radio_box_style">
          <template v-for="ele in item.groupKeyList">
            <Radio :label="ele.key">{{ ele.name }}</Radio>
          </template>
        </RadioGroup>
      </div>
    </template>
    <template #footer>
      <Button @click="standardShippingSettingsModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="standardShippingSettingsBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {getCommonParamKeysData} from "@/utils/common";

export default {
  name: "standardShippingSettingsModal",
  mixins: [Mixin],
  props: {
    platformList: { // 平台数据
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      standardShippingSettingsModal: false,
      selectValue: 'stocked',
      groupKeyList: [
        {key: 'stocking', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001994')},
        {key: 'waitPicking', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004413')},
        {key: 'picked', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004412')},
        {key: 'packaged', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004684')},
        {key: 'boxed', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004130')},
        {key: 'stocked', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004327')},
      ],
      talgKey: 'distributorsSetUpMarkedShipmentConfig',
      configType: 1,
      platformConfigList: []
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  methods: {
    // 初始化数据
    initStandardShippingSettingsData() {
      let v = this;
      v.handlePlatformData();
      getCommonParamKeysData(v.userInfo.merchantId, [v.talgKey], false, true).then((data) => {
        v.standardShippingSettingsModal = true;
        data.map((item) => {
          if (item.paramKey === v.talgKey) {
            let obj = JSON.parse(item.paramValue);
            if (obj) {
              v.configType = obj.configType;
              let platformJson = obj.platformJson;
              if (obj.configType === 1) {
                let platformJson = JSON.parse(obj.platformJson);
                v.selectValue = platformJson.all;
              } else {
                v.platformConfigList.map((ele) => {
                  for (let key in platformJson) {
                    if (key === ele.platformId) {
                      ele.selectValue = platformJson[key];
                    }
                  }
                });
              }
            }
          }
        });
      });
    },

    // 处理平台数据
    handlePlatformData() {
      let v = this;
      v.platformConfigList = [];
      if (v.platformList.length > 0) {
        let platformIdList = ['temu', 'aliexpressChoice']; // 过滤掉Temu、速卖通全托管平台
        v.platformList.map((item) => {
          if (!platformIdList.includes(item.platformId)) {
            v.platformConfigList.push({
              ...item,
              groupKeyList: v.groupKeyList,
              selectValue: 'stocked'
            });
          }
        });
      }
    },

    // 保存按钮
    standardShippingSettingsBtn() {
      let v = this;
      let queryList = [
        {
          businessId: v.userInfo.merchantId,
          paramKey: v.talgKey,
          paramValue: paramValueFun(),
        }
      ];

      // 处理参数
      function paramValueFun() {
        let obj = {
          configType: v.configType,
          platformJson: {}
        };
        if (v.configType === 1) {
          obj.platformJson = JSON.stringify({all: v.selectValue});
        } else {
          v.platformConfigList.map((item) => {
            obj.platformJson[item.platformId] = item.selectValue;
          });
        }
        return JSON.stringify(obj);
      }

      v.axios.post(api.post_ymsPlatformOrder_saveMarkedShipmentSetting, queryList).then(res => {
        if (res.data.code === 0) {
          v.standardShippingSettingsModal = false;
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          v.$emit('updateData', true);
        }
      });
    },
    // 监听弹窗
    standardShippingSettingsChange(value) {
      if (!value) {
        this.selectValue = 'stocked';
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .standardShippingSettingsStyles {
  .ivu-modal-body {
    max-height: 650px;
    overflow-y: auto;
  }

  .radio_box_style {
    .ivu-radio-group-item {
      margin: 0 30px 15px 0;
    }
  }
}
</style>